import { Typography } from "@material-ui/core";

import styled from "styled-components";

export const Label = styled(Typography)`
	font-size: 13px;
	color: ${props => props.theme.palette.colors.basic[400]};
`;
